/** DOM class names for Iterable embedded message layout (SDK output + our transforms). */
export const ITERABLE_BUTTON_PARENT_CLASS = 'iterable-button-parent'
export const ITERABLE_CONTENT_CLASS = 'iterable-content'
export const ITERABLE_IMAGE_WRAPPER_CLASS = 'iterable-image'
export const ITERABLE_IMAGE_WRAPPER_BANNER_CLASSES = 'col-md-6 order-1 order-md-2'
export const ITERABLE_IMAGE_INNER_WRAPPER_CLASSES = 'image-wrapper w-100'
export const ITERABLE_CONTENT_WRAPPER_CLASSES =
  'iterable-content-wrapper col-md-6 order-md-1 order-2 content ps-4 mt-4 mt-md-0'
/** Used when wrapping Iterable card sections inside `.iterable-card-parent` (standalone). Omit inner wrapper when `omitCardItemWrapper` is set. */
export const ITERABLE_CARD_ITEM_WRAPPER_CLASSES = 'card-program-item col-12 col-md-4'
export const TEXT_SELECTORS = 'text, p, span, h1, h2, h3, h4'

export const STYLE_MAP = {
  banner: {
    parent: 'iterable-banner-parent row media-html',
    title: 'banner-title',
    body: 'banner-body',
    image: 'banner-image',
    primaryButton: 'banner-primary-btn',
    secondaryButton: 'banner-secondary-btn'
  },
  card: {
    parent: 'iterable-card-parent block card-programs',
    title: 'card-title',
    body: 'card-body',
    image: 'card-image',
    primaryButton: 'card-primary-btn',
    secondaryButton: 'card-secondary-btn'
  },
  notification: {
    parent: 'iterable-notification-parent',
    title: 'notification-title',
    body: 'notification-body',
    image: 'notification-image',
    primaryButton: 'notification-primary-btn',
    secondaryButton: 'notification-secondary-btn'
  }
} as const

export type MessageType = keyof typeof STYLE_MAP
